import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=69f97da4&scoped=true&"
import script from "./OrderType.vue?vue&type=script&lang=js&"
export * from "./OrderType.vue?vue&type=script&lang=js&"
import style0 from "./OrderType.vue?vue&type=style&index=0&id=69f97da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f97da4",
  null
  
)

export default component.exports